import useAmplitude from 'core/hooks/useAmplitude';
import PropTypes from 'prop-types';
import * as coreEntities from 'core/store/index';
import { AMPLITUDE_EVENT } from 'core/variables/constant';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Button from 'ui/atoms/Button/Button';
import Dialog from 'ui/organisms/dialogs/Dialog/Dialog';
import Icon from 'ui/atoms/Icon/Icon';

const DialogDesktopVersion = ({ open, onClose, t, apps }) => {
  const [detectOS, setDetectOS] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  function handleClose() {
    onClose(false);
    setIsOpen(false);
  }

  const { sendAmplitudeEvent } = useAmplitude();
  const language = useSelector((state) => coreEntities.i18n.selectors.getLanguage(state));
  const downloadApp = (os) => {
    let selectedOS = apps && apps[os.toString().toUpperCase()];
    if (selectedOS) {
      window.open(selectedOS);
    } else return;
    sendAmplitudeEvent(AMPLITUDE_EVENT.DOWNLOAD_DESKTOP_APP, { version: os });
  };

  useEffect(() => {
    if (navigator.appVersion.indexOf('Win') != -1) setDetectOS('Windows');
    if (navigator.appVersion.indexOf('Mac') != -1) setDetectOS('Mac');
    if (navigator.appVersion.indexOf('Linux') != -1) setDetectOS('Linux');
  }, []);

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  const osVersion = (os) => {
    let icon = os.toLowerCase();
    return (
      <div className="dialog-desktop-version__so-ver">
        <Icon name={icon} size="3xl" color={`${detectOS === os ? 'black' : 'default'}`} />
        <span
          className={`${
            detectOS === os ? 'dialog-desktop-version__so-ver-text--selected dialog-desktop-version__so-ver-text' : 'dialog-desktop-version__so-ver-text'
          }`}
        >
          {language === 'eu' ? (
            <>
              <span className="dialog-desktop-version__so-ver-so"> {os}</span>
              {t('desktop:Version for')}
            </>
          ) : (
            <>
              {t('desktop:Version for')} <span className="dialog-desktop-version__so-ver-so"> {os}</span>
            </>
          )}
        </span>
        <Button text={t('actions:Download')} onClick={() => downloadApp(os)} isFullWidth />
      </div>
    );
  };

  return (
    <Dialog ariaLabel={t('desktop:Desktop versions')} isCloseButtonHidden isOpen={isOpen} className={'dialog-desktop-version'} onClose={handleClose}>
      <div className="dialog-desktop-version__content">
        <div className="dialog-desktop-version__header">
          <div className="dialog-desktop-version__title">
            <Icon className={'dialog-desktop-version__title-icon'} name="desktop" size="lg" color="default" />
            <div className="dialog-desktop-version__title-text"> {t('desktop:Desktop versions')}</div>
          </div>
          <button type="button" className="dialog-desktop-version__close-button" aria-label={t('common:Close')} onClick={handleClose}>
            <Icon name="close" className={'dialog-desktop-version__close'} size="xl" />
          </button>
        </div>
        <div className="dialog-desktop-version__texts">
          <p className="dialog-desktop-version__text">{t('desktop:Access all the contents of your digital books without an internet connection')}</p>
        </div>
        <div className="dialog-desktop-version__so">
          {osVersion('Windows')}
          {osVersion('Mac')}
          {osVersion('Linux')}
        </div>
      </div>
    </Dialog>
  );
};

DialogDesktopVersion.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
  t: PropTypes.func,
  apps: PropTypes.object,
};

DialogDesktopVersion.defaultProps = {
  onClose: function () {},
  open: false,
};

export default DialogDesktopVersion;
